<div class="fixed bottom-4 right-4 md:bottom-6 md:right-6">
    <button
        class="shadow w-10 aspect-square rounded-full bg-yellow-500 flex items-center justify-center hover:scale-105 transition"
        (click)="scrollToTop()">
        <fa-icon [icon]="faArrowUp" class=""></fa-icon>
    </button>
</div>